export const root = "rq4agur";
export const logo = "lvtukb6";
export const logoMember = "l1lj9vcy";
export const sponsoredText = "s1wwigv3";
export const userStat = "ubsze5m";
export const videoContainer = "vdt4s6o";
export const ctaBlock = "c1y3m1bd";
export const ctaButton = "c1ee5yw7";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");